import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, Event } from '@angular/router';
import {
    PageNavigationTrackingEvent,
    TrackingInput,
} from '@app/@core/models/tracking-event.model';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { InstrumentationService } from '../instrumentation/instrumentation.service';

@Injectable({ providedIn: 'root' })
export class RouteTrackingService implements OnDestroy {
    private lastUrl?: string;
    private lastPageEnterTime?: number;
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private instrumentationService: InstrumentationService
    ) {
        this.listenToRouteChanges();
    }

    private listenToRouteChanges(): void {
        this.router.events
            .pipe(
                filter(
                    (event: Event) =>
                        event instanceof NavigationStart ||
                        event instanceof NavigationEnd
                ),
                takeUntil(this.destroy$)
            )
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    // User leaving a page → log time spent
                    if (this.lastPageEnterTime && this.lastUrl) {
                        const durationMs = Date.now() - this.lastPageEnterTime;
                        const trackingInput: TrackingInput<PageNavigationTrackingEvent> =
                            {
                                eventName: 'PAGE_NAVIGATION',
                                eventSource: 'Menu',
                                eventLabel: '',
                                fromUrl: this.lastUrl,
                                toUrl: event.url, // upcoming navigation
                                durationMs,
                            };
                        this.instrumentationService.logEvent<PageNavigationTrackingEvent>(
                            trackingInput
                        );
                    }
                }

                if (event instanceof NavigationEnd) {
                    // User entered a new page
                    this.lastUrl = event.urlAfterRedirects;
                    this.lastPageEnterTime = Date.now();
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
